import React, { useEffect, useState } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { isMobile } from "react-device-detect";
import clsx from 'clsx';

import EndCallButton from '../EndCallButton/EndCallButton';
import ToggleAudioButton from '../ToggleAudioButton/ToggleAudioButton';
import ToggleVideoButton from '../ToggleVideoButton/ToggleVideoButton';
import ToggleScreenShareButton from '../ToogleScreenShareButton/ToggleScreenShareButton';
import '../style.css';

import useIsUserActive from '../useIsUserActive/useIsUserActive';
import useRoomState from '../../../hooks/useRoomState/useRoomState';
import useLocalAudioToggle from '../../../hooks/useLocalAudioToggle/useLocalAudioToggle';
import useLocalAudioMuteOrUnmute from '../../../hooks/useLocalAudioMuteOrUnmute/useLocalAudioMuteOrUnmute';
import useLocalVideoToggle from '../../../hooks/useLocalVideoToggle/useLocalVideoToggle';
import useDataTrack from '../../../hooks/useDataTrack/useDataTrack';

import useParticipantsAudioToggle from '../../../hooks/useParticpantsAudioToggle/useParticipantsAudioToggle';

import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';
import { LocalAudioTrack } from 'twilio-video';
import useIsTrackEnabled from '../../../hooks/useIsTrackEnabled/useIsTrackEnabled';


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      position: 'absolute',
      right: '50%',
      transform: 'translate(50%, 30px)',
      bottom: '50px',
      zIndex: 1,
      transition: 'opacity 1.2s, transform 1.2s, visibility 0s 1.2s',
      opacity: 0,
      visibility: 'hidden',
      '&.showControls, &:hover, &.visible-on-desktop': {
        zIndex: 500,
        opacity: 1,
        visibility: 'visible',
      },
    },
  })
);

const doSomethingCool = (text:any) => {

}

export default function Controls(props: any) {
  const classes = useStyles();
  const [isAudioEnabled, toggleAudioEnabled] = useLocalAudioToggle();
  const [audioMute, muteUnmuteAudio] = useLocalAudioMuteOrUnmute();

  const [isVideoEnabled, toggleVideoEnabled] = useLocalVideoToggle();

  const { room: {localParticipant},localTracks } = useVideoContext();
  const { room } = useVideoContext();


  const audioTrack = localTracks.find(track => track.kind === 'audio') as LocalAudioTrack;
  const isEnabled = useIsTrackEnabled(audioTrack);
  let localDataTrackPublication;


  const [isParticipantsAudioEnabled, toggleParticipantsAudio] = useParticipantsAudioToggle();

  const roomState = useRoomState();
  const isReconnecting = roomState === 'reconnecting';
  const isUserActive = useIsUserActive();
  const showControls = isUserActive || roomState === 'disconnected';

  const [noPermissionDialog, setNoPermissionDialog] = useState(false)

  useEffect(() => {
    const intervalId = setInterval(() => { 
      
      navigator.mediaDevices.getUserMedia({ audio: true, video: true })
        .then(function (stream) {
          if (stream.getVideoTracks().length > 0 && stream.getAudioTracks().length > 0) {
           // setNoPermissionDialog(false)
            
            //code for when none of the devices are available
          } else {
           // setNoPermissionDialog(true)
            window.sessionStorage.removeItem('twilioPatientToken')
            // code for when both devices are available
          }
        })
        .catch(function (error) {
          // code for when there is an error
         // setNoPermissionDialog(true)
          window.sessionStorage.removeItem('twilioPatientToken')
        });

        // working backup if above one has any issue
        // navigator.permissions.query({name:'camera'}).then((result) => {
        //   console.log(result);
        //   if (result.state === 'granted') {
        //     // showMap(); 
        //   } else if (result.state === 'prompt') {
        //     // showButtonToEnableMap(); Ask permission
        //   }
        //   // Don't do anything if the permission was denied.
        //   });
    }, 10000);

    return () => {
      clearInterval(intervalId); 
    }


  },[]);




  // Send the message

  if(window.localStorage.getItem('unmute') && window.localStorage.getItem('unmute') == "true"){
    window.localStorage.removeItem('unmute')
    if(audioTrack){
      muteUnmuteAudio(props, false)
    }
     // audioTrack.enable();
  }

  if(props.patient && props.patient.activeCall && props.patient.activeCall.isMute == "true"){
    if(audioTrack){
      muteUnmuteAudio(props, true)
    }
     // audioTrack.disable();
  }


  if(window.localStorage.getItem('newParticipant') && window.localStorage.getItem('newParticipant') == "true"){
    if(props.videoThumbnail && props.videoThumbnail == true){

    } else {
      window.localStorage.removeItem('newParticipant')
      window.localStorage.removeItem('muteAudio')
      {
        setTimeout(() => {
          muteUnmuteAudio(props, true)

        }, 6000);
      }
      //audioTrack.disable();
    }
    
  }
  
  // if(roomState && roomState == 'disconnected' && !(props.audioTrack && props.videoTrack)){
  //   // console.log(props.audioTrack && props.videoTrack)
  //   // console.log(props.audioTrack && props.videoTrack)
  //   alert('route')
  // }
  // navigator.mediaDevices.getUserMedia({ audio: true, video: true })
  //   .then(function (stream) {
  //     if (stream.getVideoTracks().length > 0 && stream.getAudioTracks().length > 0) {
  //       console.log('code for when both devices are available')
  //       //code for when none of the devices are available
  //     } else {
        
  //       console.log('code for when none of the devices are available')
  //       // code for when both devices are available
  //     }
  //   })
  //   .catch(function (error) {
  //     // code for when there is an error
  //     console.log('code for when there is an error')
  //   });
  let isDesktopView = false
  let controlClassList = clsx(classes.container, { showControls }) + ' fixedControls videoroom-controls'

  const ua = navigator.userAgent.toLowerCase();
  if(!/android|iphone|ipad|mobile/i.test(ua)){
    isDesktopView = true
    controlClassList = controlClassList  + " visible-on-desktop"
  } 
  
  console.log(isDesktopView, controlClassList )


  return (
    <div className={controlClassList}>
      {/* {props.muteUnmuteAllParticipants && <div className="control-container"><button className={"control-button" + (isParticipantsAudioEnabled ? " unmuted" : " muted")}
        onClick={() => toggleParticipantsAudio(props)} disabled={isReconnecting}></button></div>
      } */}
      {/* 
      <div className="control-container"><button className="control-button pause"></button></div> */}

     {/* {noPermissionDialog == true && <div className="noPermissionDialog">
        
     Your browser doesn't have sufficient permission to connect the call. Please go to your system settings and give the camera and the microphone appropriate permissions.


      </div>} */}
      
      <div className="control-container"><button className={"control-button" + (isAudioEnabled ? " unmuted" : " muted")}
                                          onClick={() => toggleAudioEnabled(props)} disabled={isReconnecting}></button></div>
      <div className="control-container"><button className={"control-button" + (isVideoEnabled ? " camera-on" : " camera-off")}
                                          onClick={() => toggleVideoEnabled()} disabled={isReconnecting}></button></div>
      {!props.hideFullScreen && (props.fullScreen ? 
      <div className={isDesktopView ? "control-container toggle-screen" :"control-container hide-button" }><button className="control-button minimize" onClick={props.toggleFullScreen}></button></div> :
      <div className={isDesktopView ? "control-container toggle-screen" :"control-container hide-button" }><button className="control-button expand" onClick={props.toggleFullScreen}></button></div>)}
     {isMobile && !props.hideMenu &&  <div className="control-container mobile-menu"><button className="control-button mobilemenu" onClick={() => props.toggleSidebar ? props.toggleSidebar() : undefined}><span></span><span></span><span></span>{props.notifyMenu && <span  id="notification-sign"></span>}</button></div>}
      {roomState !== 'disconnected' && (
        <>
        <ToggleScreenShareButton disabled={isReconnecting} />
        <div className="control-container"><button className="control-button disconnect"onClick={() => {
            window.sessionStorage.removeItem("twilioToken");
            if(props && props.endCall){
              props.endCall();
            }else{
              window.location.replace('/thank-you');
            }
            room.disconnect()
            }} ></button></div>
        </>
      )}
    </div>
  );
}
